import { render } from "./accountReview.vue?vue&type=template&id=e30ce116&scoped=true"
import script from "./accountReview.vue?vue&type=script&lang=js"
export * from "./accountReview.vue?vue&type=script&lang=js"

import "./accountReview.vue?vue&type=style&index=0&id=e30ce116&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e30ce116"

export default script